import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

/**
 * Снимок данных блока «Активы» после prepareData (для стора / RTK-наблюдателей).
 * Модели finhelper (PseudoActive, ActiveModel) — ссылки на объекты, не для devtools serialize.
 */
export type FunnelActivesChartSnapshot = {
    managerId: string | number;
    actives: any[];
    clients: any[];
    userFilteredActives: any[];
    accountFilteredActives: any[];
    activeActiveIds: any[];
    valuationSum: number;
    blockedSum: number;
    indexActives: any[];
    userIndex: any[];
    userActives: any[];
    userIndexActives: any[];
    accountIndex: any[];
    accountActives: any[];
    accountIndexActives: any[];
    currencies: any[];
};

export type FunnelActivesSliceState = {
    chart: FunnelActivesChartSnapshot | null;
};

const initialState: FunnelActivesSliceState = {
    chart: null,
};

const funnelActivesSlice = createSlice({
    name: 'funnelActives',
    initialState,
    reducers: {
        setChartSnapshot(state, action: PayloadAction<FunnelActivesChartSnapshot>) {
            state.chart = action.payload;
        },
        clearChartSnapshot(state) {
            state.chart = null;
        },
    },
});

export const {setChartSnapshot, clearChartSnapshot} = funnelActivesSlice.actions;

export default funnelActivesSlice.reducer;

export const selectFunnelActivesChart = (state: {funnelActives?: FunnelActivesSliceState}) =>
    state.funnelActives?.chart ?? null;
